<mat-dialog-content>
  {{'iap_reconnect.desc' | translate}}
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button class="ok-button" (click)="reconnect()">{{'iap_reconnect.button' | translate}}</button>
</mat-dialog-actions>
